import { Location } from '../../../shared';
import { Product } from './product';
import { TransferDetail} from './transfer-detail';

export class Transfer {
    id: number;
    workflow: string;
    type: string = 'Regular';
    sent: TransferDetail;
    requested: TransferDetail;
    status: string;

    constructor(
        public origin: Location,
        public destination: Location,
        public products: Array<Product>,
        isRequest: boolean
    ) {
        this.workflow = isRequest ? 'Request' : 'Send';
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/shared/models/transfer.ts